import _extends from 'babel-runtime/helpers/extends';

import { mapGetters } from 'vuex';

import crmTypeModel from '@/views/crm/model/crmTypeModel';
import { crmLeadsIndexAPI } from '@/api/crm/leads';
import { crmCustomerIndexAPI } from '@/api/crm/customer';
import { crmContactsIndexAPI, crmContactsQueryBusinessAPI } from '@/api/crm/contacts';
import { crmBusinessIndexAPI } from '@/api/crm/business';
import { crmContractIndexAPI } from '@/api/crm/contract';
import { crmProductSaleIndexAPI } from '@/api/crm/product';
import { crmSceneIndexAPI } from '@/api/crm/common';
// 客户下商机和联系人
import { crmCustomerQueryBusinessAPI, crmCustomerQueryContractAPI, crmCustomerQueryContactsAPI } from '@/api/crm/customer';

export default {
  name: 'CrmRelativeTable', // 相关模块CRMCell
  components: {
    CRMAllCreate: function CRMAllCreate() {
      return import('@/views/crm/components/CRMAllCreate');
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    /** 多选框 只能选一个 */
    radio: {
      type: Boolean,
      default: true
    },
    /** 没有值就是全部类型 有值就是当个类型 */
    crmType: {
      type: String,
      default: ''
    },
    /** 已选信息 */
    selectedData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /**
     * default 默认  condition 固定条件筛选
     * relative: 相关 添加
     */
    action: {
      type: Object,
      default: function _default() {
        return {
          type: 'default',
          data: {}
        };
      }
    }
  },
  data: function data() {
    return {
      loading: false, // 加载进度
      searchContent: '', // 输入内容
      isCreate: false, // 控制新建
      scenesList: [], // 场景信息
      scene_id: '',

      list: [], // 表数据
      fieldList: [], // 表头数据
      currentPage: 1, // 当前页数
      totalPage: 1, // 总页数

      otherItems: [],
      selectedItem: [] // 勾选的数据 点击确定 传递给父组件
    };
  },

  computed: _extends({}, mapGetters(['crm']), {
    canSave: function canSave() {
      if (this.action.hasOwnProperty('showCreate')) {
        return this.action.showCreate;
      }
      return this.crm && this.crm[this.crmType] && this.crm[this.crmType].save;
    },
    showSearch: function showSearch() {
      if (this.action.hasOwnProperty('showSearch')) {
        return this.action.showSearch;
      }
      return true;
    },


    // 能否查看详情
    canShowDetail: function canShowDetail() {
      if (this.action.hasOwnProperty('canShowDetail')) {
        return this.action.canShowDetail;
      }
      return this.crm && this.crm[this.crmType] && this.crm[this.crmType].index;
    },


    // 展示相关效果 去除场景
    isRelationShow: function isRelationShow() {
      return this.action.type === 'condition';
    },
    showScene: function showScene() {
      if (this.action.hasOwnProperty('showScene')) {
        return this.action.showScene;
      }
      return !this.isRelationShow && this.crmType != 'product';
    }
  }),
  watch: {
    crmType: function crmType(newValue, oldValue) {
      if (newValue != oldValue) {
        this.fieldList = [];
        this.getFieldList();
      }
    },
    action: function action(val) {
      // if (this.action != val) {
      this.scene_id = '';
      this.list = []; // 表数据
      this.fieldList = []; // 表头数据
      this.currentPage = 1; // 当前页数
      this.totalPage = 1; // 总页数
      if (this.show) {
        if (!this.isRelationShow && this.showScene) {
          this.getSceneList();
        } else {
          this.getFieldList();
        }
      }
      // }
    },
    show: {
      handler: function handler(val) {
        if (val && this.fieldList.length == 0) {
          console.log('show', val);
          // 相关列表展示时不需要场景 直接获取展示字段
          if (!this.isRelationShow && this.showScene) {
            this.getSceneList();
          } else {
            this.getFieldList();
          }
        }
      },

      deep: true,
      immediate: true
    },
    // 选择
    selectedData: function selectedData() {
      this.checkItemsWithSelectedData();
    }
  },
  mounted: function mounted() {},

  methods: {
    /**
     * 刷新列表
     */
    refreshList: function refreshList() {
      this.currentPage = 1;
      this.getList();
    },
    getSceneList: function getSceneList() {
      var _this = this;

      if (!this.canShowDetail) {
        return;
      }
      this.loading = true;
      crmSceneIndexAPI({
        types: crmTypeModel[this.crmType]
      }).then(function (res) {
        var defaultScene = res.data.list.filter(function (item, index) {
          return item.is_default === 1;
        });
        _this.scenesList = res.data.list;
        if (defaultScene && defaultScene.length > 0) {
          _this.scene_id = defaultScene[0].scene_id;
        } else {
          _this.scene_id = '';
        }

        _this.scenesList.unshift({ scene_id: '', name: '全部' });

        _this.getFieldList();
      }).catch(function () {
        _this.loading = false;
      });
    },

    /** 获取字段 */
    getFieldList: function getFieldList() {
      if (!this.canShowDetail) {
        return;
      }

      if (this.fieldList.length == 0) {
        this.fieldList = this.getDefaultField();
      }
      // 获取好字段开始请求数据
      this.getList();
    },

    /** 获取列表请求 */
    getDefaultField: function getDefaultField() {
      if (this.crmType === 'leads') {
        return [{ name: '线索名称', field: 'name', formType: 'leads' }, { name: '下次联系时间', field: 'next_time', formType: 'datetime' }, { name: '最后跟进时间', field: 'update_time', formType: 'datetime' }, { name: '创建时间 ', field: 'create_time', formType: 'datetime' }];
      } else if (this.crmType === 'customer') {
        return [{ name: '客户名称', field: 'name', formType: 'customer' }, { name: '邮箱', field: 'email', formType: 'text' }, { name: '下次联系时间', field: 'next_time', formType: 'datetime' }, { name: '最后跟进时间', field: 'update_time', formType: 'datetime' }, { name: '创建时间 ', field: 'create_time', formType: 'datetime' }];
      } else if (this.crmType === 'contacts') {
        return [{ name: '姓名', field: 'name', formType: 'contacts' }, { name: '手机', field: 'mobile', formType: 'mobile' }, { name: '电话', field: 'telephone', formType: 'text' }, { name: '是否关键决策人', field: 'decision', formType: 'text' }, { name: '职务', field: 'post', formType: 'text' }];
      } else if (this.crmType === 'business') {
        return [{ name: '商机名称', field: 'name', formType: 'text' }, { name: '商机金额', field: 'money', formType: 'text' }, { name: '客户名称', field: 'customer_name', formType: 'text' }, { name: '商机状态组 ', field: 'type_id_info', formType: 'text' }, { name: '状态 ', field: 'status_id_info', formType: 'text' }];
      } else if (this.crmType === 'contract') {
        return [{
          name: '合同名称',
          field: this.isRelationShow ? 'name' : 'name',
          formType: 'text'
        }, { name: '合同编号', field: 'num', formType: 'text' }, { name: '客户名称', field: 'customer_name', formType: 'text' }, { name: '合同金额', field: 'money', formType: 'text' }, { name: '开始日期', field: 'start_time', formType: 'text' }, { name: '结束日期', field: 'end_time', formType: 'text' }];
      } else if (this.crmType === 'product') {
        return [{ name: '产品名称', field: 'name', formType: 'text' }, { name: '单位', field: 'unit', formType: 'text' }, { name: '价格', field: 'price', formType: 'text' }, { name: '产品类别', field: 'category_name', formType: 'text' }];
      } else if (this.crmType === 'invoiceTitle') {
        return [{ field: 'title_type', formType: 'text', name: '抬头类型' }, { field: 'invoice_title', formType: 'text', name: '开票抬头' }, { field: 'tax_number', formType: 'text', name: '纳税人识别号' }, { field: 'deposit_bank', formType: 'text', name: '开户行' }, { field: 'deposit_account', formType: 'text', name: '开户账号' }, { field: 'deposit_address', formType: 'text', name: '开票地址' }, { field: 'phone', formType: 'text', name: '电话' }];
      }
    },

    /** 获取列表数据 */
    getList: function getList() {
      var _this2 = this;

      this.loading = true;
      var crmIndexRequest = this.getIndexRequest();
      var params = { search: this.searchContent
        // 注入场景
      };if (this.scene_id) {
        params.scene_id = this.scene_id;
      }
      // 注入关联ID
      if (this.isRelationShow) {
        // this.action.data.moduleType 下的 this.crmType 的列表
        if (this.action.data.moduleType) {
          crmIndexRequest = {
            customer: {
              business: crmCustomerQueryBusinessAPI,
              contacts: crmCustomerQueryContactsAPI,
              contract: crmCustomerQueryContractAPI
            },
            contacts: {
              business: crmContactsQueryBusinessAPI
            }
          }[this.action.data.moduleType][this.crmType];

          params[this.action.data.moduleType + '_id'] = this.action.data[this.action.data.moduleType + 'Id'] || this.action.data[this.action.data.moduleType + '_id'];

          if (this.action.data.params) {
            for (var field in this.action.data.params) {
              params[field] = this.action.data.params[field];
            }
          }
        }
      } else {
        params.page = this.currentPage;
        params.limit = 10;
        // params.type = crmTypeModel[this.crmType]
      }

      if (this.action.request) {
        crmIndexRequest = this.action.request;
      }

      if (this.action.params) {
        params = _extends({}, params, this.action.params);
      }
      if (this.crmType === 'product') {
        params.is_status = 1;
      }
      crmIndexRequest(params).then(function (res) {
        _this2.list = res.data.list;
        /**
         *  如果已选择的有数据
         */

        if (_this2.selectedData[_this2.crmType]) {
          _this2.checkItemsWithSelectedData();
        } else {
          _this2.list = res.data.list;
        }

        _this2.totalPage = Math.ceil(res.data.dataCount / 10);
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },

    // 标记选择数据
    checkItemsWithSelectedData: function checkItemsWithSelectedData() {
      var _this3 = this;

      var selectedArray = this.selectedData[this.crmType] ? this.selectedData[this.crmType].map(function (item) {
        item.has = false;
        return item;
      }) : [];

      var selectedRows = [];
      this.otherItems = [];

      this.list.forEach(function (item, index) {
        selectedArray.forEach(function (selectedItem, selectedIndex) {
          if (item[_this3.crmType + '_id'] == selectedItem[_this3.crmType + '_id']) {
            selectedItem.has = true;
            selectedRows.push(item);
          }
        });
      });

      selectedArray.forEach(function (selectedItem, selectedIndex) {
        if (!selectedItem.has) {
          _this3.otherItems.push(selectedItem);
        }
      });

      this.$nextTick(function () {
        _this3.$refs.relativeTable.clearSelection();
        selectedRows.forEach(function (row) {
          _this3.$refs.relativeTable.toggleRowSelection(row, true);
        });
      });
    },

    /** 获取列表请求 */
    getIndexRequest: function getIndexRequest() {
      if (this.crmType === 'leads') {
        return crmLeadsIndexAPI;
      } else if (this.crmType === 'customer') {
        return crmCustomerIndexAPI;
      } else if (this.crmType === 'contacts') {
        return crmContactsIndexAPI;
      } else if (this.crmType === 'business') {
        return crmBusinessIndexAPI;
      } else if (this.crmType === 'contract') {
        return crmContractIndexAPI;
      } else if (this.crmType === 'product') {
        return crmProductSaleIndexAPI;
      }
    },
    fieldFormatter: function fieldFormatter(row, column, cellValue) {
      if (this.crmType === 'invoiceTitle' && column.property == 'title_type') {
        return {
          1: '单位',
          2: '个人'
        }[row[column.property]];
      }
      return row[column.property] === '' || row[column.property] === null ? '--' : row[column.property];
    },

    // 场景选择
    sceneSelect: function sceneSelect() {
      this.getList();
    },

    /** 列表操作 */
    // 当某一行被点击时会触发该事件
    handleRowClick: function handleRowClick(row, column, event) {},

    // 当选择项发生变化时会触发该事件
    handleSelectionChange: function handleSelectionChange(val) {
      var _this4 = this;

      if (this.radio) {
        // this.$refs.relativeTable.clearSelection();
        val.forEach(function (row, index) {
          if (index === val.length - 1) return;
          _this4.$refs.relativeTable.toggleRowSelection(row, false);
        });
        if (val.length === 0) {
          this.selectedItem = [];
        } else {
          this.selectedItem = val.length === 1 ? val : [val[val.length - 1]];
        }
      } else {
        this.selectedItem = this.otherItems.concat(val);
      }
      this.$emit('changeCheckout', {
        data: this.selectedItem,
        type: this.crmType
      });
    },
    clearAll: function clearAll() {
      this.$refs.relativeTable.clearSelection();
    },

    // 	当用户手动勾选全选 Checkbox 时触发的事件
    selectAll: function selectAll() {},

    // 进行搜索操作
    searchInput: function searchInput() {
      this.currentPage = 1;
      this.totalPage = 1;
      this.getList();
    },
    changePage: function changePage(type) {
      if (type == 'up') {
        this.currentPage = this.currentPage - 1;
      } else if (type == 'down') {
        this.currentPage = this.currentPage + 1;
      }
      if (this.currentPage <= this.totalPage && this.currentPage >= 1) {
        this.getList();
      }
    }
  }
};